import { forwardRef } from "react";
import { ChevronDown } from "lucide-react";

const Select = forwardRef(({ options, ...props }, ref) => (
  <div className="relative w-full!">
    <select
      ref={ref}
      {...props}
      className={`adai-form-input appearance-none cursor-pointer pr-12!`}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
    <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
      <ChevronDown size={18} className="text-slate-400" />
    </div>
  </div>
));

export default Select;